import React from 'react';
import { faRouteHighway } from '@fortawesome/pro-regular-svg-icons/faRouteHighway';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function RouteHighwayRegularIcon(props) {
  return <FontAwesomeIcon icon={faRouteHighway} {...props} />;
}
